import classNames from 'classnames'
import {FileUploadIcon, HelpIcon, TrashIcon} from '../../../icons'
import InputInfo from '../../../components/core/inputInfo'
import {useCallback} from 'react'
import {colors} from '../../../utils/colors'
import Error from '../../../components/core/error'
import {statuspageAdvancedSchema} from '../../../utils/validation'
import * as Yup from 'yup'
import {useSelector} from 'react-redux'
import useDynamicValidation from '../../../utils/hooks/useDynamicValidation'

const AdvancedFormImage = ({
    isDisabled,
    names,
    currentSrc,
    setCurrentSrc,
    text,
    imageRef,
    active,
    setActive,
    getImage,
    getSignedUrl,
    setFieldValue
}) => {
    const isDarkMode = useSelector(state => state.sidebar.isDarkMode)

    const DEFAULT_IMAGE_TYPE = 'logo'

    const createImageSchema = useCallback(() => {
        const base = statuspageAdvancedSchema()
        return Yup.object().shape({
            logo: base.fields.logo,
            favicon: base.fields.favicon
        })
    }, [])

    const {
        validateData,
        clearErrors,
        errors
    } = useDynamicValidation(createImageSchema)

    const handleFileChange = async(e) => {
        const fieldName = names.image === DEFAULT_IMAGE_TYPE ? 'logo' : 'favicon'
        const files = e.target.files

        if (!files || !files.length) {
            clearErrors(fieldName)
            setFieldValue(fieldName, null)
            return
        }

        const file = files[0]
        const {isValid} = await validateData({[fieldName]: file}, fieldName)
        if (!isValid) return

        await getSignedUrl(e, setFieldValue)
        getImage()
    }

    const fieldKey = names.image === DEFAULT_IMAGE_TYPE ? 'logo' : 'favicon'
    const fieldHasError = !!errors[fieldKey]
    const defaultError = errors.default

    return (
        <div className="w-100 form-element">
            <input
                key={currentSrc}
                disabled={isDisabled}
                type="file"
                name={names.image}
                id={names.image}
                accept={names.image === DEFAULT_IMAGE_TYPE ? '.png,.jpg,.jpeg,.webp' : '.ico,.png'}
                onChange={handleFileChange}
            />
            <div
                className={classNames('file-upload', {
                    dark: isDarkMode,
                    error: fieldHasError || defaultError,
                    disable: isDisabled
                })}
            >
                <div className={classNames({images: currentSrc})}>
                    {currentSrc ? (
                        <img className="content-img" src={currentSrc} alt={`${names.image}`} />
                    ) : (
                        <FileUploadIcon />
                    )}
                    {currentSrc && (
                        <span
                            className="remover"
                            onClick={() => {
                                setCurrentSrc(null)
                                setFieldValue(fieldKey, null)
                                clearErrors(fieldKey)
                            }}
                        >
                            <TrashIcon stroke={colors.colorWhite} />
                        </span>
                    )}
                </div>

                <label htmlFor={names.image} className="image-label">
                    <span
                        className="placeholder"
                        dangerouslySetInnerHTML={{
                            __html: names.image === DEFAULT_IMAGE_TYPE ? text.logo_requirements : text.favicon_requirements
                        }}
                    />
                    <span className="upload">
                        {names.image === DEFAULT_IMAGE_TYPE ? text.upload_logo : text.upload_favicon}
                    </span>
                </label>

                <div
                    ref={imageRef}
                    className={`help ${active === names.image ? 'active' : ''}`}
                    onClick={() => setActive(active === names.image ? '' : names.image)}
                >
                    <span><HelpIcon /></span>
                    <InputInfo text={names.image === DEFAULT_IMAGE_TYPE ? text.logo_info : text.favicon_info} />
                </div>
            </div>

            {errors[fieldKey] && <Error error={errors[fieldKey]} />}
            {defaultError && <Error error={defaultError} />}
        </div>
    )
}

export default AdvancedFormImage
